export default __webpack_public_path__ + "static/media/grn-summary.92fae117.svg";